var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-card page-wrapper"},[_c('ControlDetalladoPagoDocentePorSedeTab'),_c('notifications',{attrs:{"group":"notifications","position":"top right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }